import { VerticalVideoGalleryProps } from '@ahc-digital/component-library';
import { useConditionalRendering } from 'src/shared/useConditionalRendering';
import { getDroplink } from 'src/shared/param-utils';
import { VERTICAL_VIDEO_CARD_CONTAINER } from 'src/shared/static';
import { C42VerticalVideoGalleryProps } from './C42VerticalVideoGallery.types';

export function GetVerticalVideoGallery(
  props?: C42VerticalVideoGalleryProps
): VerticalVideoGalleryProps {
  const { fields, params, rendering } = props || {};
  const { renderRichText, renderText } = useConditionalRendering();
  type t = VerticalVideoGalleryProps;
  const videoIds =
    rendering?.placeholders?.[VERTICAL_VIDEO_CARD_CONTAINER]?.map((card) =>
      card.fields?.YouTubeID?.value?.trim()
    )
      .filter((videoId): videoId is string => Boolean(videoId))
      .slice(0, 6) ?? [];
  const ctaValue = fields?.Cta?.value;
  const ctaHref = ctaValue?.href?.trim();
  const ctaLabel = ctaValue?.text?.trim() || ctaValue?.title?.trim() || '';

  return {
    backgroundColor: getDroplink<t['backgroundColor']>(params?.BackgroundColor, 'white'),
    headline: renderText(fields?.Headline, { required: true }),
    headlineTag: getDroplink<t['headlineTag']>(params?.HeadlineTag, 'h2'),
    supportCopy: renderRichText(fields?.SupportCopy),
    cta: ctaHref
      ? {
          href: ctaHref,
          label: ctaLabel,
        }
      : undefined,
    ctaStyle:
      getDroplink<'default' | 'inverse'>(params?.CtaStyle, 'inverse') === 'default'
        ? 'primary'
        : 'secondary',
    videoIds,
  };
}
